export const academyTranslations: Record<string, Record<string, string>> = {
  en: {
    "academy.badge": "VittaSathi Academy",
    "academy.h1": "VittaSathi Academy: Financial Wisdom for the World",
    "academy.slogan": "Master the science of money in your own language — wherever you are.",
    "academy.learningTicker": "Currently Learning: 4,289 Sathis",
    "academy.learningTickerTemplate": "Currently Learning: {count} Sathis",

    // Path toggle
    "academy.toggleGlobal": "🌍 Global Wisdom",
    "academy.toggleIndian": "🇮🇳 Indian Vikas",

    // 4 Pillars
    "academy.pillarsTitle": "The 4 Pillars of Financial Mastery",
    "academy.pillar1Title": "🧠 Money Mindset",
    "academy.pillar1Desc": "Overcome the urge to 'flex' and spend. Learn the psychology that separates the wealthy from the broke.",
    "academy.pillar1Tag": "Universal",
    "academy.pillar1T1": "Spending Psychology",
    "academy.pillar1T2": "Delayed Gratification",
    "academy.pillar1T3": "Needs vs Wants Framework",

    "academy.pillar2Title": "⚙️ The Compounding Machine",
    "academy.pillar2Desc": "How time creates wealth. The math of growth is a universal law — whether in $ or ₹.",
    "academy.pillar2Tag": "Universal",
    "academy.pillar2T1": "Rule of 72",
    "academy.pillar2T2": "Power of Starting Early",
    "academy.pillar2T3": "Asset Allocation Basics",

    "academy.pillar3Title": "📱 The Digital Money Revolution",
    "academy.pillar3Desc": "Mastering digital payments, neobanks, and navigating modern tax systems.",
    "academy.pillar3Tag": "Regional",
    "academy.pillar3T1": "Digital Payments & Wallets",
    "academy.pillar3T2": "Online Banking Security",
    "academy.pillar3T3": "Modern Tax Deep Dive",

    "academy.pillar4Title": "🏆 The Sathi Strategy",
    "academy.pillar4Desc": "Build a portfolio that weathers market volatility — stocks, ETFs, and mutual funds.",
    "academy.pillar4Tag": "Regional",
    "academy.pillar4T1": "Stock Research",
    "academy.pillar4T2": "Portfolio Construction",
    "academy.pillar4T3": "Step-Up Investing Strategy",

    // NRI section
    "academy.nriTitle": "Investing in India",
    "academy.nriDesc": "A guide for NRIs and global investors to legally and safely invest in the Indian growth story.",
    "academy.nriCta": "Explore NRI Guide",

    // Legacy paths
    "academy.pathsTitle": "Choose Your Learning Path",
    "academy.level1Title": "👶 Level 1: Foundations",
    "academy.level1Desc": "Master the basics — budgeting, understanding inflation, and building your safety net.",
    "academy.level2Title": "📈 Level 2: Growth",
    "academy.level2Desc": "Unlock the power of SIPs, Index Funds, and the Step-Up Secret to accelerate wealth.",
    "academy.level3Title": "💎 Level 3: Pro",
    "academy.level3Desc": "Become an expert in Stock Research Lab mastery and advanced Tax Optimization.",
    "academy.topic.budgeting": "Smart Budgeting",
    "academy.topic.inflation": "Inflation & Purchasing Power",
    "academy.topic.emergency": "Emergency Fund Planning",
    "academy.topic.sips": "SIP Strategies",
    "academy.topic.indexFunds": "Index Fund Selection",
    "academy.topic.stepUp": "The Step-Up SIP Secret",
    "academy.topic.stockLab": "Stock Research Lab Mastery",
    "academy.topic.taxOpt": "Tax Optimization Techniques",
    "academy.topic.portfolio": "Portfolio Construction",

    // Roadmap
    "academy.roadmapTitle": "30-Day Vikas Roadmap",
    "academy.roadmapSub": "Your journey from beginner to financially confident — one day at a time.",
    "academy.dayLabel": "Day",
    "academy.day1": "Set your financial goals & track your net worth",
    "academy.day2": "Understand inflation and its impact on your savings",
    "academy.day3": "Build your Emergency Fund target",
    "academy.day5": "Start your first SIP — even ₹500 counts",
    "academy.day7": "Learn the difference between Stocks, MFs, and FDs",
    "academy.day10": "Explore the Stock Research Lab",
    "academy.day14": "Compare Old vs New Tax Regime for your salary",
    "academy.day20": "Build a Debt-Free strategy with the Debt Killer tool",
    "academy.day25": "Create your Retirement projection",
    "academy.day30": "Review your Vikas Score — celebrate your progress!",

    // Lead magnet
    "academy.leadTitle": "Get the 30-Day Vikas Challenge Checklist",
    "academy.leadDesc": "A free PDF guide with daily action steps to transform your finances in 30 days.",
    "academy.emailPlaceholder": "Enter your email",
    "academy.getCta": "Get Free PDF",
    "academy.subscribed": "Check your inbox! 🎉",
    "academy.startCta": "Start Your Free Vikas Journey",
    "academy.backToTools": "Back to Tools",

    // Banner
    "academy.bannerBadge": "New — Free Academy",
    "academy.bannerTitle": "VittaSathi Academy",
    "academy.bannerSubtitle": "Financial Wisdom for the World.",
    "academy.bannerHook": "Join thousands of Sathis globally mastering their money.",
    "academy.bannerCta": "Start Your Free Vikas Journey",

    // Sidebar
    "sidebar.academy": "🔥 VittaSathi Academy",
    "sidebar.desc.academy": "Free financial literacy courses",
  },
  hi: {
    "academy.badge": "रूपीविकास अकादमी",
    "academy.h1": "रूपीविकास अकादमी: दुनिया के लिए वित्तीय ज्ञान, भारत में जड़ें",
    "academy.slogan": "अपनी भाषा में पैसे का विज्ञान सीखें — चाहे आप बेंगलुरू में हों या बर्लिन में।",
    "academy.learningTicker": "अभी सीख रहे हैं: 4,289 साथी",
    "academy.learningTickerTemplate": "अभी सीख रहे हैं: {count} साथी",

    "academy.toggleGlobal": "🌍 वैश्विक ज्ञान",
    "academy.toggleIndian": "🇮🇳 भारतीय विकास",

    "academy.pillarsTitle": "वित्तीय महारत के 4 स्तंभ",
    "academy.pillar1Title": "🧠 मनी माइंडसेट",
    "academy.pillar1Desc": "'फ्लेक्स' करने और खर्च करने की इच्छा पर काबू पाएं। अमीर और गरीब के बीच का मनोविज्ञान सीखें।",
    "academy.pillar1Tag": "सार्वभौमिक",
    "academy.pillar1T1": "खर्च का मनोविज्ञान",
    "academy.pillar1T2": "विलंबित संतुष्टि",
    "academy.pillar1T3": "ज़रूरत vs चाहत",

    "academy.pillar2Title": "⚙️ कम्पाउंडिंग मशीन",
    "academy.pillar2Desc": "समय कैसे संपत्ति बनाता है। विकास का गणित एक सार्वभौमिक नियम है।",
    "academy.pillar2Tag": "सार्वभौमिक",
    "academy.pillar2T1": "72 का नियम",
    "academy.pillar2T2": "जल्दी शुरू करने की शक्ति",
    "academy.pillar2T3": "एसेट एलोकेशन मूल बातें",

    "academy.pillar3Title": "📱 भारत की डिजिटल क्रांति",
    "academy.pillar3Desc": "UPI, आधार-लिंक्ड बैंकिंग और 2026 भारतीय टैक्स रिजीम में महारत।",
    "academy.pillar3Tag": "भारतीय",
    "academy.pillar3T1": "UPI और डिजिटल पेमेंट",
    "academy.pillar3T2": "आधार वित्तीय लिंकिंग",
    "academy.pillar3T3": "2026 टैक्स रिजीम गहन अध्ययन",

    "academy.pillar4Title": "🏆 विकास रणनीति",
    "academy.pillar4Desc": "भारतीय बाजार की अनूठी अस्थिरता के लिए पोर्टफोलियो बनाएं — NSE, BSE और म्यूचुअल फंड।",
    "academy.pillar4Tag": "भारतीय",
    "academy.pillar4T1": "NSE/BSE स्टॉक रिसर्च",
    "academy.pillar4T2": "MF पोर्टफोलियो निर्माण",
    "academy.pillar4T3": "SIP स्टेप-अप रणनीति",

    "academy.nriTitle": "भारत में निवेश",
    "academy.nriDesc": "NRI और वैश्विक निवेशकों के लिए भारतीय विकास कहानी में कानूनी रूप से निवेश करने की गाइड।",
    "academy.nriCta": "NRI गाइड देखें",

    "academy.pathsTitle": "अपना लर्निंग पथ चुनें",
    "academy.level1Title": "👶 स्तर 1: नींव",
    "academy.level1Desc": "बजट बनाना, महंगाई समझना और इमरजेंसी फंड बनाना सीखें।",
    "academy.level2Title": "📈 स्तर 2: विकास",
    "academy.level2Desc": "SIP, इंडेक्स फंड और स्टेप-अप सीक्रेट से दौलत बढ़ाएं।",
    "academy.level3Title": "💎 स्तर 3: प्रो",
    "academy.level3Desc": "स्टॉक रिसर्च लैब और टैक्स ऑप्टिमाइज़ेशन में महारत हासिल करें।",
    "academy.topic.budgeting": "स्मार्ट बजटिंग",
    "academy.topic.inflation": "महंगाई और क्रय शक्ति",
    "academy.topic.emergency": "इमरजेंसी फंड प्लानिंग",
    "academy.topic.sips": "SIP रणनीतियाँ",
    "academy.topic.indexFunds": "इंडेक्स फंड चयन",
    "academy.topic.stepUp": "स्टेप-अप SIP सीक्रेट",
    "academy.topic.stockLab": "स्टॉक रिसर्च लैब मास्टरी",
    "academy.topic.taxOpt": "टैक्स ऑप्टिमाइज़ेशन तकनीक",
    "academy.topic.portfolio": "पोर्टफोलियो निर्माण",

    "academy.roadmapTitle": "30-दिन विकास रोडमैप",
    "academy.roadmapSub": "शुरुआत से आर्थिक आत्मविश्वास तक — एक दिन में एक कदम।",
    "academy.dayLabel": "दिन",
    "academy.day1": "अपने वित्तीय लक्ष्य तय करें और नेट वर्थ ट्रैक करें",
    "academy.day2": "महंगाई और बचत पर इसके प्रभाव को समझें",
    "academy.day3": "अपना इमरजेंसी फंड लक्ष्य बनाएं",
    "academy.day5": "अपनी पहली SIP शुरू करें — ₹500 भी मायने रखता है",
    "academy.day7": "स्टॉक, MF और FD में अंतर जानें",
    "academy.day10": "स्टॉक रिसर्च लैब एक्सप्लोर करें",
    "academy.day14": "अपनी सैलरी के लिए पुरानी vs नई टैक्स रिजीम तुलना करें",
    "academy.day20": "डेट किलर टूल से कर्ज मुक्ति की रणनीति बनाएं",
    "academy.day25": "अपना रिटायरमेंट प्रोजेक्शन बनाएं",
    "academy.day30": "अपना विकास स्कोर देखें — प्रगति का जश्न मनाएं!",

    "academy.leadTitle": "30-दिन विकास चैलेंज चेकलिस्ट पाएं",
    "academy.leadDesc": "30 दिनों में अपनी वित्तीय स्थिति बदलने के लिए मुफ्त PDF गाइड।",
    "academy.emailPlaceholder": "अपना ईमेल दर्ज करें",
    "academy.getCta": "मुफ्त PDF पाएं",
    "academy.subscribed": "अपना इनबॉक्स चेक करें! 🎉",
    "academy.startCta": "अपनी मुफ्त विकास यात्रा शुरू करें",
    "academy.backToTools": "टूल्स पर वापस जाएं",

    "academy.bannerBadge": "नया — मुफ्त अकादमी",
    "academy.bannerTitle": "रूपीविकास अकादमी",
    "academy.bannerSubtitle": "दुनिया के लिए वित्तीय ज्ञान, भारत में जड़ें।",
    "academy.bannerHook": "13+ भाषाओं में पैसे की महारत सीख रहे हज़ारों साथियों से जुड़ें।",
    "academy.bannerCta": "अपनी मुफ्त विकास यात्रा शुरू करें",

    "sidebar.academy": "🔥 रूपीविकास अकादमी",
    "sidebar.desc.academy": "मुफ्त वित्तीय साक्षरता कोर्स",
  },
  kn: {
    "academy.badge": "ರೂಪಿವಿಕಾಸ ಅಕಾಡೆಮಿ",
    "academy.h1": "ರೂಪಿವಿಕಾಸ ಅಕಾಡೆಮಿ: ಜಗತ್ತಿಗೆ ಆರ್ಥಿಕ ಬುದ್ಧಿವಂತಿಕೆ, ಭಾರತದಲ್ಲಿ ಬೇರೂರಿದೆ",
    "academy.slogan": "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಹಣದ ವಿಜ್ಞಾನ ಕಲಿಯಿರಿ — ನೀವು ಬೆಂಗಳೂರಿನಲ್ಲಿ ಅಥವಾ ಬರ್ಲಿನ್‌ನಲ್ಲಿ ಇರಲಿ.",
    "academy.learningTicker": "ಪ್ರಸ್ತುತ ಕಲಿಯುತ್ತಿದ್ದಾರೆ: 4,289 ಸಾಥಿಗಳು",
    "academy.learningTickerTemplate": "ಪ್ರಸ್ತುತ ಕಲಿಯುತ್ತಿದ್ದಾರೆ: {count} ಸಾಥಿಗಳು",

    "academy.toggleGlobal": "🌍 ಜಾಗತಿಕ ಜ್ಞಾನ",
    "academy.toggleIndian": "🇮🇳 ಭಾರತೀಯ ವಿಕಾಸ",

    "academy.pillarsTitle": "ಆರ್ಥಿಕ ಪ್ರಾವೀಣ್ಯದ 4 ಸ್ತಂಭಗಳು",
    "academy.pillar1Title": "🧠 ಮನಿ ಮೈಂಡ್‌ಸೆಟ್",
    "academy.pillar1Desc": "'ಫ್ಲೆಕ್ಸ್' ಮಾಡುವ ಮತ್ತು ಖರ್ಚು ಮಾಡುವ ಆಸೆಯನ್ನು ಜಯಿಸಿ. ಶ್ರೀಮಂತ ಮತ್ತು ಬಡವರ ನಡುವಿನ ಮನೋವಿಜ್ಞಾನ ಕಲಿಯಿರಿ.",
    "academy.pillar1Tag": "ಸಾರ್ವತ್ರಿಕ",
    "academy.pillar1T1": "ಖರ್ಚಿನ ಮನೋವಿಜ್ಞಾನ",
    "academy.pillar1T2": "ವಿಳಂಬಿತ ತೃಪ್ತಿ",
    "academy.pillar1T3": "ಅವಶ್ಯಕತೆ vs ಆಸೆ",

    "academy.pillar2Title": "⚙️ ಕಂಪೌಂಡಿಂಗ್ ಮಷೀನ್",
    "academy.pillar2Desc": "ಸಮಯ ಹೇಗೆ ಸಂಪತ್ತನ್ನು ಸೃಷ್ಟಿಸುತ್ತದೆ. ಬೆಳವಣಿಗೆಯ ಗಣಿತ ಒಂದು ಸಾರ್ವತ್ರಿಕ ನಿಯಮ.",
    "academy.pillar2Tag": "ಸಾರ್ವತ್ರಿಕ",
    "academy.pillar2T1": "72 ನಿಯಮ",
    "academy.pillar2T2": "ಬೇಗ ಪ್ರಾರಂಭಿಸುವ ಶಕ್ತಿ",
    "academy.pillar2T3": "ಆಸ್ತಿ ಹಂಚಿಕೆ ಮೂಲಭೂತ",

    "academy.pillar3Title": "📱 ಭಾರತದ ಡಿಜಿಟಲ್ ಕ್ರಾಂತಿ",
    "academy.pillar3Desc": "UPI, ಆಧಾರ್-ಲಿಂಕ್ಡ್ ಬ್ಯಾಂಕಿಂಗ್ ಮತ್ತು 2026 ಭಾರತೀಯ ತೆರಿಗೆ ಪದ್ಧತಿ ಕರಗತ.",
    "academy.pillar3Tag": "ಭಾರತೀಯ",
    "academy.pillar3T1": "UPI ಮತ್ತು ಡಿಜಿಟಲ್ ಪಾವತಿ",
    "academy.pillar3T2": "ಆಧಾರ್ ಆರ್ಥಿಕ ಲಿಂಕಿಂಗ್",
    "academy.pillar3T3": "2026 ತೆರಿಗೆ ಪದ್ಧತಿ ಆಳವಾದ ಅಧ್ಯಯನ",

    "academy.pillar4Title": "🏆 ವಿಕಾಸ ತಂತ್ರ",
    "academy.pillar4Desc": "ಭಾರತೀಯ ಮಾರುಕಟ್ಟೆಯ ವಿಶಿಷ್ಟ ಚಂಚಲತೆಗೆ ಪೋರ್ಟ್ಫೋಲಿಯೊ ನಿರ್ಮಿಸಿ — NSE, BSE ಮತ್ತು ಮ್ಯೂಚುಯಲ್ ಫಂಡ್.",
    "academy.pillar4Tag": "ಭಾರತೀಯ",
    "academy.pillar4T1": "NSE/BSE ಷೇರು ಸಂಶೋಧನೆ",
    "academy.pillar4T2": "MF ಪೋರ್ಟ್ಫೋಲಿಯೊ ನಿರ್ಮಾಣ",
    "academy.pillar4T3": "SIP ಸ್ಟೆಪ್-ಅಪ್ ತಂತ್ರ",

    "academy.nriTitle": "ಭಾರತದಲ್ಲಿ ಹೂಡಿಕೆ",
    "academy.nriDesc": "NRI ಮತ್ತು ಜಾಗತಿಕ ಹೂಡಿಕೆದಾರರಿಗೆ ಭಾರತೀಯ ಬೆಳವಣಿಗೆ ಕಥೆಯಲ್ಲಿ ಕಾನೂನುಬದ್ಧವಾಗಿ ಹೂಡಿಕೆ ಮಾಡುವ ಮಾರ್ಗದರ್ಶಿ.",
    "academy.nriCta": "NRI ಮಾರ್ಗದರ್ಶಿ ನೋಡಿ",

    "academy.pathsTitle": "ನಿಮ್ಮ ಕಲಿಕೆಯ ಮಾರ್ಗ ಆಯ್ಕೆಮಾಡಿ",
    "academy.level1Title": "👶 ಮಟ್ಟ 1: ಅಡಿಪಾಯ",
    "academy.level1Desc": "ಬಜೆಟ್ ಮಾಡುವುದು, ಹಣದುಬ್ಬರ ಅರ್ಥಮಾಡಿಕೊಳ್ಳುವುದು ಮತ್ತು ತುರ್ತು ನಿಧಿ ಸೃಷ್ಟಿಸುವುದನ್ನು ಕಲಿಯಿರಿ.",
    "academy.level2Title": "📈 ಮಟ್ಟ 2: ಬೆಳವಣಿಗೆ",
    "academy.level2Desc": "SIP, ಇಂಡೆಕ್ಸ್ ಫಂಡ್ ಮತ್ತು ಸ್ಟೆಪ್-ಅಪ್ ರಹಸ್ಯದಿಂದ ಸಂಪತ್ತು ವೃದ್ಧಿಸಿ.",
    "academy.level3Title": "💎 ಮಟ್ಟ 3: ಪ್ರೊ",
    "academy.level3Desc": "ಸ್ಟಾಕ್ ರಿಸರ್ಚ್ ಲ್ಯಾಬ್ ಮತ್ತು ತೆರಿಗೆ ಆಪ್ಟಿಮೈಸೇಶನ್ ಪ್ರಾವೀಣ್ಯ ಪಡೆಯಿರಿ.",
    "academy.topic.budgeting": "ಸ್ಮಾರ್ಟ್ ಬಜೆಟಿಂಗ್",
    "academy.topic.inflation": "ಹಣದುಬ್ಬರ ಮತ್ತು ಖರೀದಿ ಶಕ್ತಿ",
    "academy.topic.emergency": "ತುರ್ತು ನಿಧಿ ಯೋಜನೆ",
    "academy.topic.sips": "SIP ತಂತ್ರಗಳು",
    "academy.topic.indexFunds": "ಇಂಡೆಕ್ಸ್ ಫಂಡ್ ಆಯ್ಕೆ",
    "academy.topic.stepUp": "ಸ್ಟೆಪ್-ಅಪ್ SIP ರಹಸ್ಯ",
    "academy.topic.stockLab": "ಸ್ಟಾಕ್ ರಿಸರ್ಚ್ ಲ್ಯಾಬ್ ಮಾಸ್ಟರಿ",
    "academy.topic.taxOpt": "ತೆರಿಗೆ ಆಪ್ಟಿಮೈಸೇಶನ್ ತಂತ್ರಗಳು",
    "academy.topic.portfolio": "ಪೋರ್ಟ್ಫೋಲಿಯೊ ನಿರ್ಮಾಣ",

    "academy.roadmapTitle": "30-ದಿನ ವಿಕಾಸ ರೋಡ್‌ಮ್ಯಾಪ್",
    "academy.roadmapSub": "ಆರಂಭಿಕರಿಂದ ಆರ್ಥಿಕ ಆತ್ಮವಿಶ್ವಾಸದವರೆಗೆ — ಒಂದು ದಿನಕ್ಕೆ ಒಂದು ಹೆಜ್ಜೆ.",
    "academy.dayLabel": "ದಿನ",
    "academy.day1": "ನಿಮ್ಮ ಆರ್ಥಿಕ ಗುರಿಗಳನ್ನು ಹೊಂದಿಸಿ ಮತ್ತು ನಿವ್ವಳ ಮೌಲ್ಯ ಟ್ರ್ಯಾಕ್ ಮಾಡಿ",
    "academy.day2": "ಹಣದುಬ್ಬರ ಮತ್ತು ಉಳಿತಾಯದ ಮೇಲೆ ಅದರ ಪ್ರಭಾವ ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ",
    "academy.day3": "ನಿಮ್ಮ ತುರ್ತು ನಿಧಿ ಗುರಿ ನಿರ್ಮಿಸಿ",
    "academy.day5": "ನಿಮ್ಮ ಮೊದಲ SIP ಪ್ರಾರಂಭಿಸಿ — ₹500 ಸಹ ಮಹತ್ವ",
    "academy.day7": "ಷೇರುಗಳು, MF ಮತ್ತು FD ನಡುವಿನ ವ್ಯತ್ಯಾಸ ತಿಳಿಯಿರಿ",
    "academy.day10": "ಸ್ಟಾಕ್ ರಿಸರ್ಚ್ ಲ್ಯಾಬ್ ಅನ್ವೇಷಿಸಿ",
    "academy.day14": "ನಿಮ್ಮ ಸಂಬಳಕ್ಕೆ ಹಳೆ vs ಹೊಸ ತೆರಿಗೆ ಪದ್ಧತಿ ಹೋಲಿಸಿ",
    "academy.day20": "ಡೆಟ್ ಕಿಲ್ಲರ್ ಉಪಕರಣದಿಂದ ಸಾಲ-ಮುಕ್ತ ತಂತ್ರ ರಚಿಸಿ",
    "academy.day25": "ನಿಮ್ಮ ನಿವೃತ್ತಿ ಪ್ರೊಜೆಕ್ಷನ್ ರಚಿಸಿ",
    "academy.day30": "ನಿಮ್ಮ ವಿಕಾಸ ಸ್ಕೋರ್ ನೋಡಿ — ಪ್ರಗತಿಯನ್ನು ಆಚರಿಸಿ!",

    "academy.leadTitle": "30-ದಿನ ವಿಕಾಸ ಚಾಲೆಂಜ್ ಚೆಕ್‌ಲಿಸ್ಟ್ ಪಡೆಯಿರಿ",
    "academy.leadDesc": "30 ದಿನಗಳಲ್ಲಿ ನಿಮ್ಮ ಹಣಕಾಸನ್ನು ಪರಿವರ್ತಿಸಲು ಉಚಿತ PDF ಮಾರ್ಗದರ್ಶಿ.",
    "academy.emailPlaceholder": "ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ",
    "academy.getCta": "ಉಚಿತ PDF ಪಡೆಯಿರಿ",
    "academy.subscribed": "ನಿಮ್ಮ ಇನ್‌ಬಾಕ್ಸ್ ಪರಿಶೀಲಿಸಿ! 🎉",
    "academy.startCta": "ನಿಮ್ಮ ಉಚಿತ ವಿಕಾಸ ಪ್ರಯಾಣ ಪ್ರಾರಂಭಿಸಿ",
    "academy.backToTools": "ಟೂಲ್ಸ್‌ಗೆ ಹಿಂತಿರುಗಿ",

    "academy.bannerBadge": "ಹೊಸ — ಉಚಿತ ಅಕಾಡೆಮಿ",
    "academy.bannerTitle": "ರೂಪಿವಿಕಾಸ ಅಕಾಡೆಮಿ",
    "academy.bannerSubtitle": "ಜಗತ್ತಿಗೆ ಆರ್ಥಿಕ ಬುದ್ಧಿವಂತಿಕೆ, ಭಾರತದಲ್ಲಿ ಬೇರೂರಿದೆ.",
    "academy.bannerHook": "13+ ಭಾಷೆಗಳಲ್ಲಿ ಹಣವನ್ನು ಕರಗತ ಮಾಡಿಕೊಳ್ಳುತ್ತಿರುವ ಸಾವಿರಾರು ಸಾಥಿಗಳೊಂದಿಗೆ ಸೇರಿ.",
    "academy.bannerCta": "ನಿಮ್ಮ ಉಚಿತ ವಿಕಾಸ ಪ್ರಯಾಣ ಪ್ರಾರಂಭಿಸಿ",

    "sidebar.academy": "🔥 ರೂಪಿವಿಕಾಸ ಅಕಾಡೆಮಿ",
    "sidebar.desc.academy": "ಉಚಿತ ಆರ್ಥಿಕ ಸಾಕ್ಷರತೆ ಕೋರ್ಸ್‌ಗಳು",
  },
};
